import { Pipe, PipeTransform } from '@angular/core';
import AppSettings from '../../app.settings';

@Pipe({ name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
  private formatDateOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  public transform(value: string | Date, type: string = AppSettings.FORMAT_DATE_PIPE_DATETIME_TYPE): string {
    if (!value) {
      return '';
    }

    if (typeof value === 'string') {
      const dateParts: string[] = value.split(' ');
      return type === AppSettings.FORMAT_DATE_PIPE_DATETIME_TYPE ? dateParts.join(', ') : dateParts[0];
    }

    return value.toLocaleDateString('en-US', this.formatDateOptions);
  }
}
